import { coreRequest } from "../core";

export const refundOrder = async (
  resId?: any | undefined,
  source = null
): Promise<any> => {
  const siteId = process.env.SITE_ID || 31;
  const queryData = {
    reservationId: resId,
    siteId: siteId,
  };
  const apiUrl = `/hello-rewards/refundorder`;

  const response = await coreRequest({
    url: apiUrl,
    data: queryData,
    source: source,
  });
  return response;
};

export default refundOrder;
